import Accordion from 'accordion-js';

window.addEventListener('DOMContentLoaded', () => {
  const accordionElements = Array.from(document.querySelectorAll('.js-accordion-container:not(.education-components)'));
  if (accordionElements.length > 0) {
    const accordions = new Accordion(accordionElements, { duration: 300 });
  }

});